/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ApproveWithdrawalOptions,
  ApproveWithdrawalResponses,
} from '../types/ApproveWithdrawal'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Approves a PENDING withdrawal, stamping approved_by/approved_at and transitioning it to APPROVED_WITHOUT_FEE. The reserved funds stay reserved; there is no ledger change. Approval does not by itself make the withdrawal eligible for on-chain submission by the withdrawal daemon: no fee has been quoted or locked at this point, and only fee-locked (APPROVED) withdrawals are submittable. Only PENDING withdrawals may be approved, so a repeated approval returns 409 rather than approving twice. An APPROVED_WITHOUT_FEE withdrawal may still be rejected, which releases its reservation.
 * @summary Approve a pending USDC withdrawal (admin)
 * {@link /v1/web3/admin/withdrawals/:withdrawal_id/approve}
 */
export function approveWithdrawal<ThrowOnError extends boolean = true>(
  options: Options<ApproveWithdrawalOptions, ThrowOnError>,
): Unwrappable<RequestResult<ApproveWithdrawalResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/web3/admin/withdrawals/{withdrawal_id}/approve',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ApproveWithdrawalResponses, ThrowOnError>>,
  )
}
